export default "__VITE_ASSET__DiIH$dyv__"